import React, { useState } from 'react';
import { BrowserRouter as Router, Route, Switch, Redirect, useHistory } from 'react-router-dom';
import Main from './Main';
import Login from './components/Login';
import Signup from './components/Signup';
import ProtectedRoute from './components/ProtectedRoute';
import axios from 'axios';
import { UserDetails } from './types/form';
import { AuthProvider, useAuth } from './context/AuthContext';

// Separate component that uses hooks
function AppContent() {
  const { push } = useHistory();
  const [backendError, setBackendError] = useState('');
  const { login } = useAuth();

  const handleLogin = async (credentials: { phone: string; password: string }) => {
    try {
      const response = await axios.post('https://api.update-ai.com/account/login', {
        phone: credentials.phone,
        password: credentials.password,
      });
      if(response.data.status === 'succss') {
        login(response.data.data.token);
      }
    } catch (error: any) {
      console.error('Login failed:', error.response?.data?.message || 'Login failed');
      setBackendError(error.response?.data?.message || 'Login failed');
    }
  };

  const handleSignup = async (userData: UserDetails) => {
    try {
      const response = await axios.post('https://api.update-ai.com/users/addUser', {
        name: userData.name,
        email: userData.email,
        phone: userData.phone,
        password: userData.password,
        address: {
          streetName: userData.street,
          apartmentNumber: userData.apartmentNo + '',
          floorNumber: userData.floor + '',
          propertyNumber: userData.buildingNo,
          governorate: userData.government,
          city: userData.city,
          district: userData.area,
        }
      });
      if(response.data.status === 'succss') {
        push('/login');
      }
    } catch (error: any) {
      console.error('Login failed:', error.response.data.message);
      setBackendError(error.response.data.message);
    }
  };

  const handleErrorClear = () => {
    setBackendError('');
  };

  return (
    <Switch>
      <Route 
        exact 
        path="/login" 
        render={(props) => (
          <Login {...props} onLogin={handleLogin} error={backendError} onErrorClear={handleErrorClear} />
        )}
      />
      <Route 
        exact 
        path="/signup" 
        render={(props) => (
          <Signup {...props} onSignup={handleSignup} error={backendError} onErrorClear={handleErrorClear} />
        )}
      />
      <Route
        exact
        path="/"
        render={() => (
          <ProtectedRoute>
            <Main />
          </ProtectedRoute>
        )}
      />
    </Switch>
  );
}

// Main App component that provides Router and Auth context
function App() {
  return (
    <Router>
      <AuthProvider>
        <AppContent />
      </AuthProvider>
    </Router>
  );
}

export default App;
